module.exports = __webpack_public_path__ + "media/images/emails/facebook-b814f0328037fbe734886ff82c17c78b.png";